export { default as LinkButton } from 'remote-com-shared/components/CallToAction/Link';
